import {ChangeDetectorRef, Component, Input, NgZone, OnInit} from '@angular/core';
import {IEmbedConfiguration} from 'embed';
import * as pbi from 'powerbi-client';
import * as $ from 'jquery';
import {BackgroundType, Permissions, TokenType, ViewMode} from 'powerbi-models';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiClhubService} from '../../../_services/apiClhub.service';
import {Subject} from 'rxjs';
import {EmbedConfig} from '../../../_models/EmbedConfig';
import {User} from '../../../_models/user.model';
import {AuthenticationService} from '../../../_services/authentication.service';
import {UserOrGroupModel} from '../../../_models/DAL/UserOrGroup.model';
import {FavoritePowerBIObjectModel} from '../../../_models/DAL/FavoritePowerBIObject.model';
import { AutoRefresh } from 'src/environments/app.global';

@Component({
  selector: 'app-dashboard-view',
  templateUrl: './dashboard-view.component.html',
  styleUrls: ['./dashboard-view.component.css']
})
export class DashboardViewComponent implements OnInit {
  private refreshIntervalId: any;
  private  asAutoRefresh: boolean = false;
  private _authenticationSubject: Subject<EmbedConfig> = new Subject<EmbedConfig>();
  public AuthenticationBI = this._authenticationSubject.asObservable();
  private currentUser: User;
  public DashboardName = '';
  public FavoriteDashboard = false;
  private currentDashboard: any;


  constructor(private route: ActivatedRoute, private router: Router,
              private ngZone: NgZone, private apiClient: ApiClhubService, private cdRef: ChangeDetectorRef,
              private authenticationService: AuthenticationService) {


                
                this.currentUser = this.authenticationService.currentUserValue;
                
                this.route.params.subscribe(result => {
                  
                  this.apiClient.get('PowerBi/embedPowerBIObject?powerBIObjectId=' + result.id +
                    '&azureIdCurrentUser=' + this.currentUser.azure_id +
                    '&userPincipalName=' + this.currentUser.email +
                    '&groupsId=' + this.currentUser.groupsid.join(';') +
                    '&customData=' + this.currentUser.email).subscribe(EmbedConfigResult => {
                      this._authenticationSubject.next(EmbedConfigResult);
                    });
                    
                    // Dès que nous avons notre authentication
                    this.AuthenticationBI.subscribe(authenticationResult => {
                      this.currentDashboard = authenticationResult;
                      
                      if (this.currentDashboard.favoriteEmbed) {
                        this.FavoriteDashboard = true;
                      }
                      
                      this.DashboardName = this.currentDashboard.embeddedObjectName;
                      this.cdRef.detectChanges();
                      
                      // Report FilterPane display
                      const filterPane = false;
                      
                      // Embed URL
                      const embedUrl = 'https://msit.powerbi.com/dashboardEmbed?dashboardId=' +
                      this.currentDashboard.powerBIObject.azureObjectId  + '&groupId=' + this.currentDashboard.powerBIObject.azureWorkspaceId;
                      this.asAutoRefresh = AutoRefresh.dashboard.includes(this.currentDashboard.powerBIObject.id );

                      
          // Configuration used to describe the what and how to embed.
          // This object is used when calling powerbi.embed.
          // This also includes settings and options such as filters.
          // You can find more information at https://github.com/Microsoft/PowerBI-JavaScript/wiki/Embed-Configuration-Details.
          const config: IEmbedConfiguration = {
            type: 'dashboard',
            accessToken: this.currentDashboard.embedToken.token,
            tokenType: TokenType.Embed,
            embedUrl: embedUrl,
            uniqueId: this.currentDashboard.powerBIObject.azureObjectId,
            groupId: this.currentDashboard.powerBIObject.azureWorkspaceId,
            settings: {
              filterPaneEnabled: filterPane,
              navContentPaneEnabled: true,
              background: BackgroundType.Transparent
            },
            viewMode: ViewMode.View,
            permissions: Permissions.Read
          };

          // Grab the reference to the div HTML element that will host the report.
          const reportContainer = <HTMLElement>document.getElementById('dashboardContainer');

          // Embed the report and display it within the div container.
          const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
          const reportFinal = powerbi.embed(reportContainer, config)  as pbi.Embed & pbi.Report;
          if(this.asAutoRefresh){
            // 🔁 Rafraîchissement automatique toutes les 60 secondes
            this.refreshIntervalId = setInterval(() => {
              reportFinal.refresh();
              console.log(`refresh ${this.refreshIntervalId}` );
            }, AutoRefresh.dashBoardRefresTime);
          }
          reportFinal.iframe.frameBorder = '0px';
          $('#dashboardContainer>iframe').css('height', '88vh');

          // Report.off removes a given event handler if it exists.
          reportFinal.off('loaded');

          // Report.on will add an event handler which prints to Log window.
          reportFinal.on('loaded', function() {
            // reportFinal.fullscreen();
            reportFinal.iframe.mozRequestFullScreen();
          });
        });
      });
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }
  
}
